module.exports = __webpack_public_path__ + "img/Active-Managers.809d1f6a.png";